let deferredPrompt

const isSupported = ('serviceWorker' in navigator)
const isStandalone = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches
const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent)

console.log({
  isSupported,
  isStandalone,
  isIos
})

export default {
  register: () => {
    if (!isSupported) return

    document.body.classList.add('has-pwa-support')
    document.body.classList.add('has-installed-pwa')

    if (isIos && !isStandalone) {
      document.body.classList.add('is-iois')
      document.body.classList.remove('has-installed-pwa')
    }

    window.addEventListener('beforeinstallprompt', e => {
      document.body.classList.remove('has-installed-pwa')
      deferredPrompt = e
    })

    navigator.serviceWorker.register('sw.js')
  },

  prompt: async () => {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') deferredPrompt = null
  }
}
